// No imports are needed for this file as it only uses process.env (which is available in create-react-app by default).
const Constants = {
  URL: 'https://backend.emesmart.com',
  URL_COMPLEMENTO: process.env.REACT_APP_URL_COMPLEMENTO,
  // URL_COMPLEMENTO: 'http://localhost:4000',
  VERSION: 'v0.1',
};
export default Constants;
